import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation updateUser($file: Upload, $user: UpdateUserInput!) {
    updateUser(
      file: $file,
      updateUser: $user,
    ) {
      user {
        id,
        firstName,
        lastName,
        image,
        countryCode,
        phone,
        email,
        channelFoundUs,
        isEmailConfirmed,
        acceptedTerms,
        location,
        placeId,
        address,
        addressInfo {
          streetAddress,
          townCity,
          zipCode,
          country,
        },
      },
      id,
      success,
      messages,
    }
  }`;
